// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router'
import store from './store'

import {ClientTable} from 'vue-tables-2'
import VueMasonry from 'vue-masonry-css'

Vue.use(ClientTable)
Vue.use(VueMasonry)

// Set this to false to prevent the production tip on Vue startup.
Vue.config.productionTip = false
Vue.config.devtools = false
Vue.config.debug = false

// set baseUrl from app
// axios.defaults.baseURL = 'http://' + window.location.hostname + ':8080/static/api/'
axios.defaults.baseURL = 'http://maosapi.inogs.it/v0.1'

Vue.use(VueAnalytics, {
  id: 'UA-2130807-49',
  router
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js